export default "https://static.zego.com/_next/static/chunks/fonts/ModernEra-BoldItalic-c96949fe07927163b2b91e541e69ef3d.woff2";